<mat-button-toggle-group
  [value]="selectedToolMode$ | async"
  (change)="setMode($event.value)"
>
  @for (button of buttons; track button) {
    <mat-button-toggle
      class="toolbar-button"
      [matTooltip]="button.tooltip"
      [value]="button.value"
    >
      <mat-icon [h3CustomIcon]="button.icon"></mat-icon>
    </mat-button-toggle>
  }
</mat-button-toggle-group>
